import styled from 'styled-components';

export const Main = styled.main.attrs(() => ({
  className: 'main',
}))`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
  background: ${({ bg }) => (bg ? bg : `var(--theme-palette-bg-dark)`)};

  @media (max-width: 767px) {
    .product-layout & {
      background: transparent;
    }
  }
`;
